import { Injectable } from '@angular/core';
import { CameraService } from './camera.service';
import { PlatformService } from './platform.service';
import { Camera, CameraResultType, CameraSource, GalleryImageOptions, ImageOptions } from '@capacitor/camera';

@Injectable({
  providedIn: 'root'
})
export class CameraCapacitorService {
  constructor(
    private platformService: PlatformService,
    private cameraService: CameraService
  ) {}

  async takePhoto() {
    if (!(await this.cameraService.ensureCameraPermission())) {
      return;
    }

    if (await this.platformService.isBelowAndroid13()) {
      if (!(await this.cameraService.ensureLegacyAndroidStoragePermission())) {
        return;
      }
    }

    const cameraOptions: ImageOptions = {
      allowEditing: false,
      source: CameraSource.Camera,
      resultType: CameraResultType.Uri,
      saveToGallery: true,
      quality: 85
    };

    try {
      return await Camera.getPhoto(cameraOptions);
    } catch (error) {
      if (this.cameraService.isCameraPermissionError(error)) {
        await this.cameraService.notifyCameraPermissionDenied();
        return;
      }

      if (this.cameraService.isUserCancelledError(error)) {
        return;
      }

      throw error;
    }
  }

  async selectPicture() {
    if (!(await this.cameraService.ensurePhotosPermission())) {
      return;
    }

    if (await this.platformService.isBelowAndroid13()) {
      if (!(await this.cameraService.ensureLegacyAndroidStoragePermission())) {
        return;
      }
    }

    const cameraOptions: GalleryImageOptions = {
      quality: 50,
      limit: 1
    };

    try {
      return await Camera.pickImages(cameraOptions);
    } catch (error) {
      if (this.cameraService.isGalleryPermissionError(error)) {
        await this.cameraService.notifyPhotosPermissionDenied();
        return;
      }

      if (this.cameraService.isUserCancelledError(error)) {
        return;
      }

      throw error;
    }
  }
}
